/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobileProduction = {
  aws_project_region: "ap-northeast-1",
  aws_cognito_region: "ap-northeast-1",
  aws_user_pools_id: "ap-northeast-1_Pc2RXL4gQ",
  aws_user_pools_web_client_id: "54lplv0u939vmtcrt3suav4jfu",
};

const awsmobileStaging = {
  aws_project_region: "ap-northeast-1",
  aws_cognito_region: "ap-northeast-1",
  aws_user_pools_id: "ap-northeast-1_r43vecMgb",
  aws_user_pools_web_client_id: "5j6294a5kkgv7sdq79k9bdojec",
};

const awsmobileDev = {
  aws_project_region: "ap-northeast-1",
  aws_cognito_region: "ap-northeast-1",
  aws_user_pools_id: "ap-northeast-1_mQ2UBVpj4",
  aws_user_pools_web_client_id: "1iskjtd7jr2b56d2enhvnumgma",
};

const awsmobile = {
  prod: awsmobileProduction,
  staging: awsmobileStaging,
  dev: awsmobileDev,
};

const currentEnv = process.env.REACT_APP_ENV || "dev";

export default awsmobile[currentEnv] || awsmobileDev;
